import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadershipService {

  private apiUrl = environment.apiBaseUrl + '/api/';

  constructor(private http: HttpClient) { }

  getAllLeadership(langCode: string): Observable<any> {
    if (langCode === '') {
      return this.http.get(`${this.apiUrl}leadership`);
    }

    return this.http.get(`${this.apiUrl}leadership?lang=${langCode}`);
  }

  getLeadershipById(id: number, langCode: string): Observable<any> {
    if (langCode === '') {
      return this.http.get(`${this.apiUrl}leadership/${id}`);
    }

    return this.http.get(`${this.apiUrl}leadership/${id}?lang=${langCode}`);
  }

  create(request: any): Observable<any> {
    const formData = new FormData();

    if (request.image) {
      formData.append('Image', request.image);
    }

    formData.append('Data', JSON.stringify(request.data));

    return this.http.post(`${this.apiUrl}leadership`, formData);
  }

  update(id: number, request: any): Observable<any> {
    const formData = new FormData();

    if (request.image) {
      formData.append('Image', request.image);
    }

    formData.append('Data', JSON.stringify(request.data));

    return this.http.put(`${this.apiUrl}leadership/${id}`, formData);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}leadership/${id}`);
  }
}
